<template>
  <div class="search-items">
    <div class="title" v-if="title">{{title}}</div>
    <div class="items-content">
      <div class="items-content-child">
        <div class="all-items items" v-if="!none" :class="{isSelect: isSelect === -1}" @click="selectOne(-1, 'all')">
          全部{{all ? `(${all})` : ''}}
        </div>
        <div
          class="items"
          v-for="(item, index) in typeList"
          :key="item[defaultKey.value] + item[defaultKey.label]"
          :class="{isSelect: isSelect === index}"
          @click="selectOne(index, item)"
        >
          {{item[defaultKey.label]}}
        </div>
        <div
          class="items"
          v-for="(item, index) in secondList"
          :key="item[defaultKey.value] + item[defaultKey.label]"
          :class="{isSelect: isSelect === index}"
          @click="selectOne(index, item)"
        >
          {{item[defaultKey.label]}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLcWeb } from '@/api/lc_web'
export default {
  data () {
    return {
      isSelect: this.select,
      zqo: []
    }
  },
  props: {
    select: {
      type: [String, Number],
      default: -1
    },
    status: {
      type: Boolean
    },
    selectParent: {
      type: [String, Number]
    },
    all: Number,
    none: Boolean,
    title: String,
    typeList: Array,
    secondList: Array,
    defaultKey: {
      type: Object,
      default: () => {
        return {
          label: 'name',
          value: 'id'
        }
      }
    }
  },
  watch: {
    // select (val) {
    //   this.isSelect = val
    // }
  },
  methods: {
    selectOne (index, item) {
      this.isSelect = index
      if (this.status) {
        this.$emit('plateClick', item, index)
      } else {
        this.$emit('click', item)
      }
      this.$emit('update', index)
    },
    async getTypes (val) {
      const res = await getLcWeb({
        name: 'lc.market.category.list',
        data: {
          parentId: val || null
        }
      })
      if (res.code === 0) {
        if (!this.status) {
          let tabsList = []
          const temp = res.value ? res.value : []
          tabsList = temp.filter(v => v.parentId === null)
          tabsList.map((i, k) => {
            if (i.id === this.select) {
              this.isSelect = k
            }
          })
        }
      }
    }
  },
  created () {
    if (!this.status) {
      this.getTypes()
    }
    if (this.status) {
      if (this.select === -1) {
        console.log(this.selectParent, 'this.selectParent')
        this.getTypes(this.selectParent)
      }
    }
  }
}
</script>

<style lang="scss">
  .search-items{
    padding: 10px 0;
    min-height: 50px;
    display: flex;
    .title{
      width: 50px;
      height: 32px;
      opacity: 1;
      font-size: 14px;
    //   text-align: center;
      color: #969696;
      line-height: 32px;
    }
    .items-content{
      display: flex;
      width: 100%;
      .all-items{
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        transition: all 0.1s linear;
        white-space: nowrap;
        min-width: 94px;
        height: 32px;
        line-height: 32px;
      }
      .items-content-child{
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        align-items: center;
      }
    }
    .items{
      display: inline-block;
      font-size: 14px;
      color: #444444;
      text-align: center;
      cursor: pointer;
      transition: all 0.1s linear;
      white-space: nowrap;
      border: 1px solid #187fc3;
      border-radius: 4px;
      min-width: 96px;
      height: 32px;
      line-height: 32px;
      margin: 0 0px 22px 22px;
    }
    .items.isSelect{
      background: #187FC3;
      border-radius: 5px;
      color: white;
    }
    .items-child{
      display: inline-block;
      font-size: 12px;
      color: #444444;
      padding: 5px 20px;
      cursor: pointer;
      transition: all 0.1s linear;
      white-space: nowrap;
      margin: 5px 0;
    }
  }
</style>
